import React, { useEffect, useMemo } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import useCommon from "hooks/useCommon";
import { setHotelIds } from "store/slice/uiSlice";
import VuiInputRoot from "components/VuiInput/VuiInputRoot";
import VuiAutocomplete from "components/AutoComplete";
import { setHotels } from "store/slice/uiSlice";
import { setHotelId } from "store/slice/uiSlice";
import dayjs from "utils/dayjs";

const HotelSelector = ({ multiple = false, minWidth = 220, width, fullWidth = false }) => {
  const { STORE, DISPATCH } = useCommon();

  const { user: userInfo } = STORE((state) => state.user);
  const hotelIds = STORE((state) => state.ui.hotelIds);

  const hotels = userInfo?.hotels || [];

  const selectedHotels = useMemo(() => {
    if (multiple) {
      return hotels.filter((h) => hotelIds.includes(h._id));
    }

    return hotels.find((h) => h._id === hotelIds?.[0]) || null;
  }, [hotels, hotelIds, multiple]);

  const selectedHotelTimezone = useMemo(() => {
    if (multiple) {
      return hotels.find((h) => h._id === hotelIds?.[0])?.timezone;
    }

    return selectedHotels?.timezone;
  }, [hotels, hotelIds, selectedHotels, multiple]);

  useEffect(() => {
    if (!hotels.length) return;
    if (hotelIds?.length) return;

    DISPATCH(setHotelIds([hotels[0]._id]));
    DISPATCH(setHotelId(hotels[0]._id));
    DISPATCH(setHotels(hotels));
  }, [hotels]);

  useEffect(() => {
    const tz = selectedHotelTimezone || "UTC";

    dayjs.tz.setDefault(tz);

    // console.log("DayJS timezone set to:", tz);

    // console.log("Current hotel time:", dayjs.tz().format("MMM D, YYYY h:mm A"));
  }, [selectedHotelTimezone]);

  return (
    <VuiBox display="flex" alignItems="center" gap={1}>
      {/* <VuiTypography variant="caption">
        Hotels:
      </VuiTypography> */}

      <VuiAutocomplete
        multiple={multiple}
        gradient={false}
        options={hotels}
        value={selectedHotels}
        placeholder="Select hotels"
        minWidth={minWidth}
        getOptionLabel={(h) => h.name || ""}
        isOptionEqualToValue={(a, b) => a._id === b._id}
        // onChange={(_, value) => {
        //   if (multiple) {
        //     const ids = value.map((v) => v._id);
        //     DISPATCH(setHotelIds(ids));
        //   } else {
        //     const id = value?._id ? [value._id] : [];
        //     DISPATCH(setHotelIds(id));
        //     DISPATCH(setHotelId(value?._id || null));
        //   }
        // }}
        onChange={(_, value) => {
          if (multiple) {
            // Prevent removing all hotels
            if (!value || value.length === 0) {
              return;
            }

            const ids = value.map((v) => v._id);
            DISPATCH(setHotelIds(ids));
          } else {
            // Prevent clearing in single mode
            if (!value?._id) {
              return;
            }

            DISPATCH(setHotelIds([value._id]));
            DISPATCH(setHotelId(value._id));
          }
        }}
      />
    </VuiBox>
  );
};

export default HotelSelector;
